module.exports = __webpack_public_path__ + "img/blog-67.80196fb1.jpg";